import { Plus } from 'lucide-react';

export function Fab() {
  return (
    <button type='button' className='mk-fab' aria-label='Add'>
      <Plus size={28} strokeWidth={2.5} />
    </button>
  );
}
